module.exports = __webpack_public_path__ + "swiper-icon-prev-44f1d07c.png";